import { useState } from 'react';

import { BottomBar, Button, Text } from 'shell/components';

const BottomBarDemo = () => {
    const [hidden, setHidden] = useState(true);

    return (
        <>
            <Text variant={'sh1'}>BottomBar</Text>

            <Button onClick={() => setHidden((current) => !current)}>Toggle Bottom Bar</Button>
            {!hidden && (
                <BottomBar>
                    <Text>Hello World!</Text>
                </BottomBar>
            )}
        </>
    );
};

export default BottomBarDemo;
